<template>
    <div class="answers-page">
        <div class="container">
            <div class="page-title">
                <h1>{{ questionsPage.page_title }}</h1>
            </div>
            <div class="answers-page-head">
                <div class="page-title-navigation">
                    <ul>
                        <li v-for="item in questionsPage.page_nav"><router-link :to="item.link == '/questions-answers' ? '/questions-answers' : '/questions-answers' + item.link">{{ item.name }}</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="answers-list-container"><router-view></router-view></div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'answers--page',
        components: {
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Вопросы и ответы',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            questionsPage: 'loadQuestionsPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            // store.dispatch('getNewsItems');
            // store.dispatch('getIndexPageData');
            // store.dispatch('getSalesItems');
            if (store.state.questionsPage != null) {
                next();
                // next(vm => {
                //     // vm.$store.commit('removePageLoaderImg');
                //     setTimeout(() => {
                //         vm.$parent.$refs.topProgress.done();
                //     }, 300);
                // });
            } else {
                store.dispatch('getQuestionsPageData').then((response) => {
                    if (response) {
                        next();
                        // next(vm => {
                        //     // vm.$store.commit('removePageLoaderImg');
                        //     setTimeout(() => {
                        //         vm.$parent.$refs.topProgress.done();
                        //     }, 300);
                        // });
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'answers';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/answers-page/answers-page.scss';
    @import '@/styles/components/answers-page/respond/answers-page-respond.scss';
</style>